import { memo, useState } from "react";
import { Button, Flex } from "@chakra-ui/react";
import { NostrEvent } from "nostr-tools";
import { getEventUID } from "applesauce-core/helpers";

import TimelineItem from "../timeline/timeline-item";

const PAGE_SIZE = 20;

function HotNoteTimeline({ timeline }: { timeline: NostrEvent[] }) {
  const [visible, setVisible] = useState(PAGE_SIZE);

  const notes = timeline.slice(0, visible);

  return (
    <>
      {notes.map((note) => (
        <TimelineItem key={getEventUID(note)} event={note} visible />
      ))}
      {visible < timeline.length && (
        <Flex justifyContent="center" py="4">
          <Button onClick={() => setVisible((v) => v + PAGE_SIZE)} variant="outline">
            Show more
          </Button>
        </Flex>
      )}
    </>
  );
}

export default memo(HotNoteTimeline);
